module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.7936/img/mobile-onboarding-powering-up.svg"